<template>
  <div ref="root" class="btn-group b-dropdown dropdown">
    <button
      type="button"
      :class="['btn', `btn-${variant}`, !noCaret && 'dropdown-toggle', toggleClass]"
      :aria-expanded="open ? 'true' : 'false'"
      aria-haspopup="true"
      @click="open = !open"
    ><slot name="button-content">{{ text }}</slot></button>
    <div :class="['dropdown-menu', right && 'dropdown-menu-right', open && 'show']"><slot></slot></div>
  </div>
</template>
<script lang="ts">
import { defineComponent, onBeforeUnmount, onMounted, provide, ref } from 'vue'
import { dropdownContextKey } from './dropdown-context'
export default defineComponent({
  name: 'BDropdown',
  props: {
    text: { type: String, default: '' },
    variant: { type: String, default: 'secondary' },
    toggleClass: { type: [String, Array, Object], default: '' },
    right: Boolean,
    noCaret: Boolean
  },
  setup() {
    const root = ref<HTMLElement | null>(null)
    const open = ref(false)
    const close = () => { open.value = false }
    const onDocumentClick = (event: MouseEvent) => {
      if (!root.value?.contains(event.target as Node)) close()
    }
    const onKeydown = (event: KeyboardEvent) => { if (event.key === 'Escape') close() }
    provide(dropdownContextKey, { close })
    onMounted(() => {
      document.addEventListener('click', onDocumentClick)
      window.addEventListener('keydown', onKeydown)
    })
    onBeforeUnmount(() => {
      document.removeEventListener('click', onDocumentClick)
      window.removeEventListener('keydown', onKeydown)
    })
    return { root, open }
  }
})
</script>
